export const packConfig = (() => {
  const taskTypeArr = [...new Array(50).keys()].map(i=>(i+1)*2);
  return taskTypeArr.map(i => {
    if([2,10,20,30,40,50].includes(i)) {
      return{
        taskType: i,
        extraTime: 1, // 1小时时长包
        expireTime: 7, // 有效期
      };
    } else if([60,70,80].includes(i)) {
      return {
        taskType: i,
        extraTime: 2, // 2小时时长包
        expireTime: 7, // 有效期
      };
    } else if([90,100].includes(i)){
      return {
        taskType: i,
        extraTime: 5, // 5小时时长包
        expireTime: 7, // 有效期
      }
    }else {
      return {
        taskType: i,
      }
    }
  })
})();


// WEBPACK FOOTER //
// ./src/page/tokyoOlympic/config.js